// Put your main state here
export default {
  counter: 1000,
  status: '',
  token: localStorage.getItem('token') || '',
  client_customers: [{ value: '', text: 'Cargando...' },],
  process: {
    markedRows: []
  },
  user: {
    ID_CLIENTE: '',
    ID_USUARIO: '',
    USUARIO: '',
    IMAGE: '',
    MENU: '',
    ACTIVO: false,
    DETAILS: false,
  }
}
